import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuSurface from "../ui/MenuSurface";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import React from "react";
export default function SetOptionsMenu({ onRename, onDelete, onChangeImage }) {
  const [menuAnchor, setMenuAnchor] = React.useState(null);
  const [menuOpen, setMenuOpen] = React.useState(false);
  const menuRef = React.useRef(null);
  const toggleMenu = () => {
    setMenuOpen((o) => !o);
  };
  return (
    <div className="menu set-menu" ref={menuRef}>
      <IconButton
        type="button"
        className="menu-toggle"
        onClick={(event) => {
          setMenuAnchor(event.currentTarget);
          toggleMenu(event);
        }}
        aria-label="Set options"
        aria-expanded={menuOpen}
        aria-haspopup="menu"
      >
        <MoreVertIcon />
      </IconButton>
      {menuOpen && (
        <MenuSurface
          anchorEl={menuAnchor}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          fitBelow
          onClose={() => setMenuOpen(false)}
        >
          {onChangeImage && (
            <MenuItem
              onClick={() => {
                onChangeImage();
                setMenuOpen(false);
              }}
              component="button"
            >
              Change Set Image
            </MenuItem>
          )}
          <MenuItem
            onClick={() => {
              onRename();
              setMenuOpen(false);
            }}
            component="button"
          >
            Rename
          </MenuItem>
          <Divider />
          <MenuItem
            sx={{ color: "error.main" }}
            onClick={() => {
              onDelete();
              setMenuOpen(false);
            }}
            component="button"
          >
            Delete Set
          </MenuItem>
        </MenuSurface>
      )}
    </div>
  );
}
